import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkerTypeLookupComponent } from './worker-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [WorkerTypeLookupComponent],
  exports: [WorkerTypeLookupComponent]
})
export class WorkerTypeLookupModule { }
